module.exports = __webpack_public_path__ + "img/03.eca1f23a.jpg";